import { render, staticRenderFns } from "./EditGoalCard.vue?vue&type=template&id=300abf76&scoped=true&"
import script from "./EditGoalCard.vue?vue&type=script&lang=js&"
export * from "./EditGoalCard.vue?vue&type=script&lang=js&"
import style0 from "./EditGoalCard.vue?vue&type=style&index=0&id=300abf76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300abf76",
  null
  
)

export default component.exports